import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_RO.json';
import exercises from './YOGA_EXERCISES_RO.json';
import recipes from './YOGA_RECIPES_RO.json';

export const YOGA_DATA_RO: ServiceData = {
  articles,
  exercises,
  recipes,
};
